// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_pagination_container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.e2e_pagination_btn,
.e2e_pagination_number {
  border: none;
  outline: none;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 8px;
  background: #f1f5f9;
  color: #334155;
  font-size: 14px;
  transition: all 0.3s ease;
}

.e2e_pagination_btn:hover,
.e2e_pagination_number:hover {
  background: #2563eb;
  color: #fff;
}

.e2e_pagination_active {
  background: #2563eb;
  color: #fff;
}

.e2e_pagination_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.e2e_pagination_numbers {
  display: flex;
  gap: 6px;
}

@media(max-width:600px){
  .e2e_pagination_container{
    justify-content:center;
    gap:6px;
    margin-top:14px;
  }

  .e2e_pagination_btn,
  .e2e_pagination_number{
    min-width:40px;
    min-height:40px;
    padding:8px 10px;
  }

  .e2e_pagination_numbers{
    max-width:calc(100vw - 130px);
    overflow-x:auto;
    scrollbar-width:none;
  }

  .e2e_pagination_numbers::-webkit-scrollbar{
    display:none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/Pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,sBAAsB;IACtB,OAAO;IACP,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".e2e_pagination_container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.e2e_pagination_btn,\r\n.e2e_pagination_number {\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n  padding: 8px 14px;\r\n  border-radius: 8px;\r\n  background: #f1f5f9;\r\n  color: #334155;\r\n  font-size: 14px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.e2e_pagination_btn:hover,\r\n.e2e_pagination_number:hover {\r\n  background: #2563eb;\r\n  color: #fff;\r\n}\r\n\r\n.e2e_pagination_active {\r\n  background: #2563eb;\r\n  color: #fff;\r\n}\r\n\r\n.e2e_pagination_btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.e2e_pagination_numbers {\n  display: flex;\n  gap: 6px;\n}\n\n@media(max-width:600px){\n  .e2e_pagination_container{\n    justify-content:center;\n    gap:6px;\n    margin-top:14px;\n  }\n\n  .e2e_pagination_btn,\n  .e2e_pagination_number{\n    min-width:40px;\n    min-height:40px;\n    padding:8px 10px;\n  }\n\n  .e2e_pagination_numbers{\n    max-width:calc(100vw - 130px);\n    overflow-x:auto;\n    scrollbar-width:none;\n  }\n\n  .e2e_pagination_numbers::-webkit-scrollbar{\n    display:none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
